/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type VerifyIdentityProviderConnectionRequestBody = {
  /**
   * Connection ID.
   */
  id: string;
};

/** @internal */
export type VerifyIdentityProviderConnectionRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const VerifyIdentityProviderConnectionRequestBody$outboundSchema:
  z.ZodMiniType<
    VerifyIdentityProviderConnectionRequestBody$Outbound,
    VerifyIdentityProviderConnectionRequestBody
  > = z.object({
    id: z.string(),
  });

export function verifyIdentityProviderConnectionRequestBodyToJSON(
  verifyIdentityProviderConnectionRequestBody:
    VerifyIdentityProviderConnectionRequestBody,
): string {
  return JSON.stringify(
    VerifyIdentityProviderConnectionRequestBody$outboundSchema.parse(
      verifyIdentityProviderConnectionRequestBody,
    ),
  );
}
